import React, { PureComponent } from 'react'
import './home.less'
export default class Home extends PureComponent {
  render () {
    return (
      <div className = "Home">
      慧途科技，商户管理后台。
        {/* <div className="header-inner flex-h-a">
          <dl className="item flex-h-a">
            <dt className="icon flex-a-a">
              <Icon type="account-book" theme="filled" style={{fontSize: 36, color: '#1ABC9C'}}/>
            </dt>
            <dd className="info">
              <div className='desc'>余额</div>
              <div className='inner'>￥200</div>
              <Button icon='money-collect' size='small'>提现</Button>
            </dd>
          </dl>
          <dl className="item flex-h-a">
            <dt className="icon flex-a-a">
              <Icon type="pound-circle" theme="filled" style={{fontSize: 36, color: '#1ABC9C'}}/>
            </dt>
            <dd className="info">
              <div className='desc'>积分剩余</div>
              <div className='inner'>999200</div>
              <Button icon='pay-circle' type="primary" size='small'>充值</Button>
            </dd>
          </dl>
          <dl className="item flex-h-a">
            <dt className="icon flex-a-a">
              <Icon type="pay-circle" theme="filled" style={{fontSize: 36, color: '#aaa'}}/>
            </dt>
            <dd className="info">
              <div className='desc'>冻结余额</div>
              <div className='inner'>￥200</div>
            </dd>
          </dl>
          <dl className="item flex-h-a">
            <dt className="icon flex-a-a">
              <Icon type="file-text" theme="filled" style={{fontSize: 36, color: '#1ABC9C'}}/>
            </dt>
            <dd className="info">
              <div className='desc'>有效订单</div>
              <div className='inner'>158</div>
            </dd>
          </dl>
          <dl className="item flex-h-a">
            <dt className="icon flex-a-a">
              <Icon type="file-unknown" theme="filled" style={{fontSize: 36, color: '#aaa'}}/>
            </dt>
            <dd className="info">
              <div className='desc'>冻结订单</div>
              <div className='inner'>158</div>
            </dd>
          </dl>
        </div> */}
      </div>
    )
  }
}